import React, { useState } from "react";
import {
  Card,
  CardActions,
  CardContent,
  Typography,
  Paper
} from "@mui/material";
import Moment from "moment";
import { useDispatch,useSelector } from "react-redux";
import {
  showTodaIncometable
} from "../../../../redux/actions/PaymentActions";
import MDButton from "components/MDButton";
const CardFile = ({ income, buildingId, title, type }) => {
  const [year,setYear] = useState(0);
  const dispatch = useDispatch();
  let dates = [];
  const date = () => {
    const date1 = new Date();
    const date2 = Moment(date1).format("YYYY");
    for (let input = 2015; input <= date2; input++) {
      dates.push(input);
    }
  };
  date();
  const years = useSelector(state =>state.payments.year)
  console.log(years)
const values =(id)=>{
  console.log(id)
  setYear(id)
}
  return (
    <Paper elevation={3} sx={{borderRadius:6}}>
    <Card sx={{ minWidth:'70%', height: "170px"}}>
      <CardContent>
        <Typography variant="h5" component="div">
          {income.toFixed()}
        </Typography>
        <Typography sx={{ mb: 1.5 }} color="text.secondary">
          {title}
        </Typography>
      </CardContent>
      <CardActions>
        <MDButton size='small' color='info' onClick={()=> dispatch(showTodaIncometable())}>Show & Close</MDButton>
      </CardActions>
    </Card>
    </Paper>
  );
};
export default CardFile;


